export default function on(el, ev, fn) {
  el.on(ev, fn)
  return () => el.off(ev, fn)
}

export function once(el, ev, fn) {
  const off = on(el, ev, (...args) => {
    off()
    return fn(...args)
  })

  return off
}
